import React, { Component } from 'react';
import { Container, Input, Label } from 'reactstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';

import HomepageGuide from "../../components/portfolio/Homepage/HomepageGuide";
import { FormattedMessage, injectIntl } from "react-intl";
import ContentLoader from "../../components/ContentLoader";
import MetaTags from '../../components/SEO/MetaTags'
import { handleRequestError, Request } from '../../helpers/request'
import { businessUnitOptions } from '../../helpers/select'
import LocaleLink from '../../components/Routes/LocaleLink'
import BusinessCategorySelect from "../../components/form/BusinessCategorySelect";
import BusinessUnitButton from "../../components/portfolio/JobsPage/BusinessUnitButton";

class DigitalJobsIndexPage extends Component
{
    state = {
        data: [],
        page: 1,
        pagination: 8,
        keywords: '',
        business_unit: this.props.match.params?.business_unit ?? null,
        business_units: [],
        business_unit_category_id: null,
        business_unit_category_options: [],
        letters: [],
        letterOptions: [],
        loading: false
    };

    componentDidMount() {
        this.fetchLetters();
        this.fetch();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.match.params?.business_unit !== this.props.match.params?.business_unit){
            this.fetch(false)
        }
    }

    fetchLetters() {
        Request.get('digital_jobs/letters')
            .then((options) => {
                let letterOptions = [];
                for (let letter of options) {
                    let el = { value: letter, label: letter.toUpperCase() };
                    letterOptions.push(el);
                }
                this.setState({ letterOptions });
            })
            .catch(handleRequestError);
    }

    fetch(concat = true, offset = null) {
        const { intl } = this.props;
        const businessUnit = this.props.match.params?.business_unit ?? null;
        this.setState({ loading: true , business_unit: businessUnit});

        const {
            keywords,
            letters,
            business_units,
            business_unit_category_id
        } = this.state

        let params = {}
        if (this.state.keywords) {
            params.keywords = this.state.keywords
        }
        if (this.state.letters.length !== 0) {
            params.letters = this.state.letters
        }
        if (this.state.business_units.length !== 0) {
            params.business_units = this.state.business_units
        }
        if (businessUnit) {
            params.business_unit = businessUnit
        }

        if (business_unit_category_id) {
            params.business_unit_category_id = business_unit_category_id
        }

        const baseUri = 'digital_jobs';
        const queryString = Object.keys(params).map(key => ('' !== params[key])?key + '=' + params[key]:'').join('&');
        const fullUri = (queryString.length === 0)? baseUri : baseUri.concat('?').concat(queryString) ;

        Request.get(fullUri)
            .then((response) => {
                const { data } = this.state;

                if(response.business_unit_category_options) {
                    response.business_unit_category_options.unshift(
                    {id: null, label: intl.formatMessage({
                            id: "portfolio.digital.pole.all.category.all.label",
                            defaultMessage: "Toutes"
                        })
                    });
                }

                this.setState({
                    data: concat ? data.concat(response.jobs) : response.jobs,
                    business_unit_category_options: response?.business_unit_category_options ?? [],
                    loading: false
                }, () => offset ? window.scrollTo(0,  offset) : null);
            })
            .catch((e) => {
                handleRequestError(e);
                this.setState({ loading: false });
            });
    }

    handleBusinessUnitFilter(business_unit) {
        let business_units = this.state.business_units;

        if (!business_units.includes(business_unit))
            business_units.push(business_unit);
        else {
            business_units.splice(business_units.indexOf(business_unit), 1);
        }

        this.setState({ business_units }, () => this.fetch(false))
    }

    handleLetterFilter(letter) {
        let letters = this.state.letters;

        if (!letters.includes(letter))
            letters.push(letter);
        else {
            letters.splice(letters.indexOf(letter), 1);
        }

        this.setState({ letters }, () => this.fetch(false))
    }

    resetFilters() {
        this.setState({
            data: [],
            keywords: '',
            business_units: [],
            letters: [],
        }, () => this.fetch());
        document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
        document.querySelector('input[id=search-input]').value = '';
    }

    search(keywords) {
        this.setState({ keywords }, () => this.fetch(false));
    }

    renderBusinessUnitOptions() {
        return businessUnitOptions.map((option, key) => {
            return (
                <li key={key}>
                    <BusinessUnitButton
                        option={option}
                        state={this.state}
                        prefix="/metiers-digital/"
                    />
                </li>
            )
        })
    }

    renderLetterOptions() {
        return this.state.letterOptions.map((option, key) => {
            return (
                <li key={key}>
                    <Label className="checkbox-warning">
                        <Input
                            type="checkbox"
                            name="radio-btn"
                            value={option.value}
                            onChange={e => this.handleLetterFilter(e.target.value)}
                        />
                        <span>{option.label}</span>
                    </Label>
                </li>
            )
        })
    }

    render() {
        const { intl } = this.props;
        const { data } = this.state;
        const translationKey = this.props.match?.params?.business_unit ?? 'home'

        if (!data)
            return <ContentLoader/>;

        return(
            <div className="digital-page">

                <MetaTags page ="digital"  data={{
                    business_unit : translationKey
                }}/>

                <section className="section-digital">
                    <Container>
                        <h1 className="line-heading">
                            {intl.formatMessage({
                                id: "portfolio.digital.pole." + translationKey + ".title",
                                defaultMessage: "Les meilleures offres d'emploi du digital"
                            })}
                        </h1>
                        <p>
                            {intl.formatMessage({
                                id: "portfolio.digital.pole." + translationKey + ".hat",
                                defaultMessage: "Retrouvez ici la description de tous les types de postes proposés par l'écosystème du digital. Des métiers tech aux opportunités de product en passant par le marketing ou le secteur commercial, découvrez quels sont les challenges et missions pour chaque profil, ainsi que leurs salaires. N'hésitez pas à nous poser des questions sur un métier en particulier."
                            })}
                        </p>

                        <div className="manager-fileds">
                            <div className="form-group" style={{flex: 1}}>
                                <label>
                                    <FormattedMessage
                                        id="portfolio.digital.search.label"
                                        defaultMessage="Cherchez par mots-clés"
                                    />
                                </label>
                                <Input
                                    type="text"
                                    id="search-input"
                                    className="input-field"
                                    placeholder={
                                        intl.formatMessage({
                                            id: "portfolio.digital.search.placeholder",
                                            defaultMessage: "Technos, métiers, compétences"
                                        })
                                    }
                                    onChange={(e) => this.search(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="manager-fileds">
                            <div className="check-list">
                                <Label>
                                    <FormattedMessage
                                        id="portfolio.digital.pole.label"
                                        defaultMessage="Sélectionnez un ou plusieurs pôles"
                                    />
                                </Label>
                                <ul>
                                    <li>
                                        <BusinessUnitButton
                                            option={{
                                                value: '',
                                                label: intl.formatMessage({
                                                    id: "portfolio.digital.pole.all.label",
                                                    defaultMessage: "Tous"
                                                })
                                            }}
                                            state={this.state}
                                            prefix="/metiers-digital/"
                                        />
                                    </li>
                                    {this.renderBusinessUnitOptions()}
                                </ul>
                            </div>
                        </div>
                        {(this.state?.business_unit) &&
                            <div className="field-wrap business-category-select">
                                <div className="form-group" style={{flex: 1}}>
                                    <label>
                                        <FormattedMessage
                                            id="portfolio.jobs.business_category.label"
                                            defaultMessage="Sélectionnez une catégorie"
                                        />
                                    </label>
                                    <BusinessCategorySelect
                                        value={this.state.business_unit_category_id}
                                        options={this.state.business_unit_category_options}
                                        onChange={business_unit_category_id => this.setState(
                                            { ...this.state, page: 1, business_unit_category_id },
                                            () => this.fetch(false)
                                        )}
                                    />
                                </div>
                            </div>
                        }
                        <div className="select-letters">
                            <Label>
                                <FormattedMessage
                                    id="portfolio.digital.letter.label"
                                    defaultMessage="Sélectionnez une ou plusieurs lettres"
                                />
                            </Label>
                            <ul>
                                {this.renderLetterOptions()}
                            </ul>
                            <span className="delete-text" onClick={() => this.resetFilters()}>
                                <i><FontAwesomeIcon icon={faTrashAlt}/>&nbsp;</i>
                                <FormattedMessage
                                    id="app.remove_filters"
                                    defaultMessage="Effacer les critères"
                                />
                            </span>
                        </div>
                    </Container>
                </section>

                <section className="section-card-list">
                    <div className="container">
                        <ul className="card-list">
                            { this.renderStartingJobs() }
                            { this.renderFindMeAJob() }
                            { this.renderEndingJobs() }
                        </ul>
                    </div>
                </section>

                <HomepageGuide/>

            </div>
        )
    }

    renderStartingJobs() {
        const {data} = this.state;
        let start = data.slice(0, 4);

        return start.map((job) => {
            return this.renderJob(job)
        });
    }

    renderEndingJobs() {
        const {data} = this.state;
        let end = data.slice(4);

        return end.map((job) => {
            return this.renderJob(job)
        });
    }

    renderFindMeAJob = () => {
        return (
            <li>
                <LocaleLink to="/candidature-spontanee">
                    <div className="card-heading">
                        <div>
                            <h2>
                                <FormattedMessage
                                    id="app.no_time_to_find_job"
                                    defaultMessage="Pas le temps de trouver un job ? On trouve pour vous."
                                />
                            </h2>
                            <div className={'text-center'}>
                                <FontAwesomeIcon icon={faArrowRight} className={'icon'}/>&nbsp;
                            </div>
                        </div>
                    </div>
                </LocaleLink>
            </li>
        )
    };

    renderJob = (job) => {
        let color = job.business_unit === 'tech' ? 'text-card-primary' :
            job.business_unit === 'marketing' || job.business_unit === 'sales' ? 'card-regular' : 'text-card-warning';

        return (
            <li key={job.id}>
                <LocaleLink to={`/metiers-digital/${job.business_unit}/${job.slug}`}>
                    <div className={`card ${color}`}>
                        <div>
                            <h2>
                                {job.title.length > 45 ? job.title.slice(0, 45) + '...' : job.title}
                            </h2>
                            <p>
                                {job.description.length > 200 ? job.description.slice(0, 200) + '...' : job.description}
                            </p>
                            <FontAwesomeIcon icon={faArrowRight}/>&nbsp;
                        </div>
                    </div>
                </LocaleLink>
            </li>
        )
    }
}

export default injectIntl(DigitalJobsIndexPage);
